// Notes SC6a R1 — a generic lazy <script> bundle loader. Unlike the reports loader (src/app.js loadTiptapBundle, left
// unchanged), a FAILED load removes its script tag, so a retry really re-requests the file instead of waiting forever on
// events that already fired. Concurrent calls share one in-flight promise per src.
const _inflight = new Map();

export function loadBundle(src, globalName) {
  if (window[globalName]) return Promise.resolve(window[globalName]);
  if (_inflight.has(src)) return _inflight.get(src);
  const p = new Promise((resolve, reject) => {
    // A leftover tag from an earlier failed attempt (or another loader) would never fire again → replace it.
    document.querySelectorAll('script[data-hud-bundle="' + src + '"]').forEach(t => t.remove());
    const s = document.createElement('script');
    s.src = src; s.async = true; s.setAttribute('data-hud-bundle', src);
    s.onload = () => { if (window[globalName]) resolve(window[globalName]); else { s.remove(); reject(new Error('bundle loaded without ' + globalName)); } };
    s.onerror = () => { s.remove(); reject(new Error('bundle load failed: ' + src)); };
    document.head.appendChild(s);
  }).finally(() => _inflight.delete(src));
  _inflight.set(src, p);
  return p;
}

export const NOTES_RICH_SRC = '/notes-rich.bundle.js';
export function loadNotesRich() { return loadBundle(NOTES_RICH_SRC, 'HUD_NOTES_RICH'); }
